import { useEffect, useMemo, useState } from "react"

//Formik
import FormikTextInput from "../../../../helpers/formikInputs/FormikTextInput"
import FormikDropDown from "../../../../helpers/formikInputs/FormikDropDown"
import FormikCheckBox from "../../../../helpers/formikInputs/FormikCheckboxInput"

//PrimeReact
import { Button } from "primereact/button"
import { useField } from "formik"
import { Tooltip } from "primereact/tooltip"

//Styles
import kioskStyles from "../../../../styles/kiosk/KioskAdmin.module.css"
import myStyles from "../../../../styles/kiosk/KioskAdminFormWizard.module.css"

export default function WizardPageProfile({ templates, onCancel, onNext }) {
  const intakeSessionName = "intake_session"
  const defaultIntakeType = "participant"

  const intakeTypeOptions = useMemo(
    () => [
      {
        title: "Full service participant",
        tooltip: "Sign up for complete, peer specialist led services.",
        value: defaultIntakeType,
      },
      {
        title: "Kiosk member",
        tooltip:
          "Sign up with our community to be able to check-in for activities.",
        value: "kioskMember",
      },
    ],
    []
  )

  const [fieldName, , helperName] = useField("name")
  const [fieldTemplate, , helperTemplate] = useField("soarTemplateName")
  const [fieldIntakeType, , helperIntakeType] = useField("soarIntakeType")
  const [intakeType, setIntakeType] = useState(
    () =>
      intakeTypeOptions.find((o) => o.value === fieldIntakeType.value)?.tooltip
  )
  const [activeTemplateName, setActiveTemplateName] = useState(
    fieldTemplate.value
  )

  useEffect(() => {
    if (fieldTemplate.value === intakeSessionName && !intakeType) {
      const intakeTypeProfile = intakeTypeOptions.find(
        (option) => option.value === defaultIntakeType
      )

      helperIntakeType.setValue(intakeTypeProfile?.value || "")
      setIntakeType(intakeTypeProfile?.tooltip)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldTemplate.value])

  const validate = () => {
    let isOk = true

    if (!fieldName.value) {
      helperName.setTouched(true)
      isOk = false
    }

    if (!fieldTemplate.value) {
      helperTemplate.setTouched(true)
      isOk = false
    }

    return isOk
  }

  const IntakeTemplate = (option) => {
    return (
      <div>
        <Tooltip target=".intakeType-tt" className="custom-tooltip" />
        <div
          className="intakeType-tt"
          data-pr-tooltip={option.tooltip}
          data-pr-position="bottom"
        >
          {option.title}
        </div>
      </div>
    )
  }

  return (
    <div className={myStyles.wizardPage}>
      <div className={myStyles.profileBody}>
        <FormikTextInput
          name={"name"}
          label={"Name"}
          helpText={"The name for this form in Kiosk"}
        />
        <FormikTextInput
          name={"description"}
          label={"Description"}
          helpText={`The description for this Kiosk form will be shown in Kiosk, under the header. 
            Can be used to provide instructions for form completion.`}
        />
        <FormikDropDown
          name={"soarTemplateName"}
          label={"Template"}
          helpText={"The template for this Kiosk form"}
          placeHolderValue={"Select a template"}
          options={templates}
          optionLabel={"template_title"}
          optionValue={"template_name"}
          onChangeCallback={(value) => {
            setActiveTemplateName(value)

            //Default the intakeType if this is now an intake template with no intake type specified
            if (value === intakeSessionName && !intakeType) {
              const defaultOption = intakeTypeOptions.find(
                (option) => option.value === defaultIntakeType
              )

              helperIntakeType.setValue(defaultOption?.value || "")
              setIntakeType(defaultOption?.tooltip)
            }
          }}
        />
        {activeTemplateName === intakeSessionName && (
          <FormikDropDown
            name={"soarIntakeType"}
            label={"Intake Type"}
            helpText={
              intakeType || "The type of intake to perform with this form"
            }
            placeHolderValue={"Select an intake type"}
            options={intakeTypeOptions}
            optionValue={"value"}
            optionLabel={"title"}
            itemTemplate={IntakeTemplate}
            onChangeCallback={(value) => {
              const selectedOption = intakeTypeOptions.find(
                (option) => option.value === value
              )
              setIntakeType(selectedOption?.tooltip)
            }}
          />
        )}
        <FormikCheckBox
          name={"active"}
          label={"Status"}
          helpText={"This field indicates whether the form is active in Kiosk"}
          useSwitch={true}
        />
      </div>
      <div className={`${myStyles.buttonGroup}  ${myStyles.bottomMargin}`}>
        <Button
          label="Cancel"
          type="button"
          onClick={() => {
            onCancel()
          }}
          className={`${kioskStyles.invertButton} ${kioskStyles.button}`}
        />
        <Button
          label="Next"
          type="button"
          onClick={() => {
            if (validate()) {
              onNext()
            }
          }}
          className={`${kioskStyles.button} ${kioskStyles.primaryButton}`}
        />
      </div>
    </div>
  )
}
